export default ({ addShit }) => {
    addShit({
        c: s => `{ color: ${ s }; }`,
        lh: s => `{ line-height: ${ s }; }`,
        'vertical-a': s => {
            const mapping = { m: 'middle', t: 'top', b: 'bottom' }
            return `{ vertical-align: ${ mapping[s] || s }; }`
        },
        'text-a': s => {
            const mapping = { l: 'left', r: 'right', c: 'center' }
            return `{ text-align: ${ mapping[s] || s }; }`
        },
        flt: s => {
            const mapping = { l: 'left', r: 'right' }
            return `{ float: ${ mapping[s] || s }; }`
        },
        'font-w': s => `{ font-weight: ${ s }; }`,
        'letter-s': s => `{ letter-spacing: ${ s }; }`,
        overflow: s => {
            const mapping = { h: 'hidden', a: 'auto' }
            return `{ overflow: ${ mapping[s] || s }; }`
        },
        'overflow-x': s => {
            const mapping = { h: 'hidden', a: 'auto' }
            return `{ overflow-x: ${ mapping[s] || s }; }`
        },
        'overflow-y': s => {
            const mapping = { h: 'hidden', a: 'auto' }
            return `{ overflow-y: ${ mapping[s] || s }; }`
        },
        'justify-c': s => {
            const mapping = { 'sb': 'space-between', c: 'center', 'sa': 'space-around', 'fe': 'flex-end' }
            return `{ justify-content: ${ mapping[s] || s }; }`
        },
        'align-i': s => {
            const mapping = { 'c': 'center' }
            return `{ align-items: ${mapping[s] || s}; }`;
        },
        'flex-w': s => {
            const mapping = { 'w': 'wrap' }
            return `{ flex-wrap: ${ mapping[s] || s }; }`
        },
        'flex-g': s => {
            return `{ flex-grow: ${s}; }`;
        },
        'flex-d': s => {
            const mapping = { 'c': 'column', 'c-r': 'column-reverse' }
            return `{ flex-direction: ${ mapping[s] || s } }`
        },
        dis: s => {
            const mapping = { 'i-b': 'inline-block', b: 'block', f: 'flex', n: 'none' }
            return `{ display: ${ mapping[s] || s }; }`
        },
        bw: s => `{ border-width: ${ s }; }`,
        bs: s => `{ border-style: ${ s }; }`,
        bt: s => {
            const mapp = { n: "none" };
            const mapping = (s === '0px' || s.indexOf('!important') > -1) ? s : mapp[s] || s + ' solid'
            return `{ border-top: ${ mapping }; }`
        },
        cursor: s => {
            const mapping = { p: 'pointer', d: 'default', n: 'not-allowed' }
            return `{ cursor: ${ mapping[s] || s }; }`
        },
        bl: s => {
            const mapping = { n: 'none' }
            return `{ border-left: ${mapping[s] || s + ' solid'}; }`;
        },
        br: s => {
            const mapping = { n: 'none' }
            return `{ border-right: ${mapping[s] || s + ' solid'}; }`;
        },
        bb: s => {
            const mapping = { n: 'none' }
            return `{ border-bottom: ${mapping[s] || s + ' solid'}; }`;
        },
        btc: s => `{ border-top-color: ${ s }; }`,
        brc: s => `{ border-right-color: ${ s }; }`,
        bbc: s => `{ border-bottom-color: ${ s }; }`,
        blc: s => `{ border-left-color: ${ s }; }`,
        bblr: s => `{ border-bottom-left-radius: ${ s } }`,
        bbrr: s => `{ border-bottom-right-radius: ${ s } }`,
        btlr: s => `{ border-top-left-radius: ${ s } }`,
        btrr: s => `{ border-top-right-radius: ${ s } }`,
        otl: s => {
            const mapping = { 'n': 'none' }
            return `{ outline: ${ mapping[s] || s }; }`
        },
        miw: s => `{ min-width: ${ s }; }`,
        mxw: s => `{ max-width: ${ s }; }`,
        mxh: s => `{ max-height: ${ s }; }`,
        mih: s => `{ min-height: ${ s }; }`,
    })
}